export default __webpack_public_path__ + "static/thumb-landscape-4d17f2a09567535ab52aeaec60a801b1.jpg";